import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, onMounted, useContext, useMeta, useRoute } from "@nuxtjs/composition-api";

import { useAmplitude, useAuth, useBranchService, useI18n, useMetaService } from "@/composables";
import { REDIRECT_IGNORE_PATHS } from "@/utils/constants";

const __default__ = defineComponent({
  name: "Login",
  middleware: "auth",
  auth: "guest",
  head: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const context = useContext();
const route = useRoute();
const auth = useAuth();
const amplitude = useAmplitude();
const branch = useBranchService();
const metaService = useMetaService();
const i18n = useI18n();

useMeta(() => ({ link: metaService.setCanonical(route.value) }));

onMounted(() => {
  /**
   * Utilizing `NuxtContext.from` allows catching users who actively clicked on the login button
   * Falling back to the auth plugin's stored redirect allows capturing users who were programmatically
   * or server side redirected by the auth middleware.
   */
  const from = context.from.value ?? auth.$storage.getUniversal("redirect");
  const shouldRedirect = from !== undefined && !REDIRECT_IGNORE_PATHS.includes(from.path);

  // set cookie to redirect to original page
  if (shouldRedirect) {
    sessionStorage.setItem("redirect", JSON.stringify(from));
  }

  /**
   * Clear nuxt-auth internal redirects to allow for an intermediary landing page before redirecting the user
   * to the intended redirect target. It is imperative that the auth plugin's default "home" redirect path
   * is used for post-auth processing, such as eventing, sending anonymous queued entity interactions, like likes, etc.
   */
  auth.$storage.removeUniversal("redirect");

  amplitude?.sendExitEvent("/page/login");
  auth.loginWith("auth0", {
    params: {
      prompt: "login",
      screen_hint: "login",
      ui_locales: i18n.locale,
      vid: branch?.vid,
    },
  });
});

return { __sfc: true,context, route, auth, amplitude, branch, metaService, i18n }
}

})